import { create } from 'zustand'
import { message as $message } from 'antd'
import { getRefundSupportPlatformConfigListUsingGET } from '@/services/afterSale'

enum ActonType {
    agreeToRefund = 'agreeToRefund',
    agreeToRefundOnly = 'agreeToRefundOnly',
    agreeToReturnGoods = 'agreeToReturnGoods',
    refuseRefund = 'refuseRefund'
}
interface NotSupportConfigItem {
    notSupportActionList: string[]
    label: string
    omitPlatForm: string
}
interface State {
    /**
     * 是否初始化
     */
    isInit: boolean
    /**
     * 支持的平台
     */
    supportPlatformMap: Record<string, string>
    /**
     * 部分平台不支持的操作的配置
     */
    notSupportListConfig: NotSupportConfigItem[]
    /**
     * 支持的平台desc
     */
    supportLabel: string[]
}

interface Action {
    getSupportPlatform: () => void
}
const actionMap = {
    [ActonType.agreeToRefund]: ['买家已退货，同意退款'],
    [ActonType.agreeToRefundOnly]: ['同意仅退款'],
    [ActonType.agreeToReturnGoods]: ['同意买家退货'],
    [ActonType.refuseRefund]: ['拒绝仅退款', '拒绝买家退货', '买家退货异常，驳回退款']
}
const LSIT = [
    ActonType.agreeToRefund,
    ActonType.agreeToRefundOnly,
    ActonType.agreeToReturnGoods,
    ActonType.refuseRefund
]

export const afterSaleRefundStore = create<State & Action>(set => ({
    isInit: false,
    supportPlatformMap: {},
    notSupportListConfig: [],
    supportLabel: [],
    getSupportPlatform: async () => {
        const { success, data, message } = await getRefundSupportPlatformConfigListUsingGET()
        if (!success) {
            $message.error(message)
            return {}
        }
        const supportPlatformMap = data?.reduce((acc: Record<string, string>, cur) => {
            if (cur.value) {
                acc[cur.value] = cur.value
            }
            return acc
        }, {})
        const supportLabel = data?.map(item => {
            return item.desc || ''
        })
        const notSupportListConfig = data?.reduce((acc: NotSupportConfigItem[], cur) => {
            const notSupportActionList = LSIT.reduce((arr: string[], item) => {
                if (!cur[item]) {
                    arr.push(...actionMap[item])
                }
                return arr
            }, [])

            if (notSupportActionList?.length) {
                acc.push({
                    notSupportActionList,
                    label: cur.desc || '',
                    omitPlatForm: cur.value || ''
                })
            }
            return acc
        }, [])

        set({ isInit: true, supportPlatformMap, notSupportListConfig, supportLabel })
        return data
    }
}))
